export default __webpack_public_path__ + "static/media/pleading-face.4303f52e.png";